<template>
			<div id="page-content" class="admin-sidebar">
				<div class="component-padding">
					
					<div id="products-admin-options">
						<h1>Purchase Products</h1>
						<div>
							<input type="text" placeholder="Search Product">
							<select name="francis">
								<option value="">All Products</option>
								<option value="">Wall Sconces</option>
								<option value="">Chandeliers</option>
								<option value="">Pendants</option>
								<option value="">Undercabinet</option>
								<option value="">Ceiling</option>
								<option value="">Desk, Floor & Table Lamps</option>
								<option value="">Track</option>
								<option value="">Architectural</option>
								<option value="">Recessed</option>
							</select>
							<select name="fabrianne">
								<option value="">All Suppliers</option>
								<option value="">Phelix Systems</option>
								<option value="">Fabrianne Inc</option>
								<option value="">Ast Corps</option>
							</select>
						</div>
					</div>
					
					<div class="products-list">
						<div class="col-md-4 product-item-admin" v-for="n in 9">
							<img src="static/images/j.jpeg" />
							<p>Supplier: <strong>Phelix Systems</strong></p>
							<p>Product Code: <strong>6SGHA14</strong></p>
							<p>Price: <strong>Php 140.00</strong> <small>FOB</small></p>
							<div class="admin-purchase-options">
								<button class="col-md-6">View Product</button>
								<button class="col-md-6">Add to Cart</button>
							</div>
						</div>
					</div>
				</div>
			</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// AdminPurchase.vue?73f2f5ce